<script setup lang="ts">
import { useMainStore } from '~/stores/useMainStore'

if (useMainStore().accessToken === null)
  useRouter().replace({ name: 'AuthLoginPage' })
</script>

<template>
  <div />
</template>

<route lang="json5">
{
name: "IndexPage",
meta: {layout:"AuthLayout"}
}
</route>
